import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const formatLabel = (key) => {
  return key
    ?.replace(/([a-z])([A-Z])/g, "$1 $2")
    ?.replace(/_/g, " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase());
};

const DynamicRules = ({ fieldData, title }) => {
  let rules = [];

  try {
    rules =
      typeof fieldData === "string"
        ? JSON.parse(fieldData)
        : fieldData;
  } catch {
    rules = [];
  }

  // Don't show anything if no rules
  if (!rules?.length) {
    return null;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        // variant="body2"
        variant="subtitle2"
        sx={{
          fontWeight: "bold",
          mb: 1,
          mt: 2,
          color: "text.primary",
        }}
      >
        {title === "InboundRules"
          ? "Inbound Rules"
          : "Outbound Rules"}
      </Typography>

     {rules.map((rule, index) => (
  <Box
    key={index}
    sx={{
      mb: 2,
    //   border: "1px solid",
      borderColor: "divider",
      borderRadius: 1,
      overflow: "hidden",
    }}
  >
    {/* Rule Heading */}
   {index > 0  &&( <Box
      sx={{
        // bgcolor: "#f5f5f5",
        // px: 2,
        py: 1,
      }}
    >
      <Typography
       variant="body2"
        sx={{ fontWeight: 600 }}
      >
        {title === "InboundRules"
          ? `InboundRule ${index + 1}`
          : `OutboundRule ${index + 1}`}
      </Typography>
    </Box> )}

    {/* Rule Details */}
   
      {Object.entries(rule)
  .filter(([key]) => {
    const normalizedKey = key
      .replace(/_/g, "")
      .toLowerCase();

    return (
      normalizedKey !== "__meta" &&
      normalizedKey !== "iseditable"
    );
  })
  .map(([key, value]) => (
        <Box
          key={`${index}-${key}`}
          sx={{
            display: "grid",
            gridTemplateColumns: "260px 1fr",
            alignItems: "center",
            py: 1.5,
            // px: 2,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "text.secondary" }}
          >
            {formatLabel(key)}:
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#1976d2",
              wordBreak: "break-word",
            }}
          >
            {value || "N/A"}
          </Typography>
        </Box>
      ))}
  </Box>
))}
    </Box>
  );
};

DynamicRules.propTypes = {
  fieldData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  title: PropTypes.string,
};

export default DynamicRules;